<div class="auth-container">
  <div class="auth-card">
    <!-- Logo & Header -->
    <div class="auth-header">
      <div class="logo-container">
        <img src="assets/logo/bee.png" alt="BizzWeaver" class="auth-logo" />
      </div>
      <h1 class="auth-title">{{ 'LOGIN_TITLE' | translate }}</h1>
      <p class="auth-subtitle">{{ 'LOGIN_SUBTITLE' | translate }}</p>
    </div>

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="error-banner">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <span>{{ errorMessage | translate }}</span>
      </div>
    }

    <section class="provider-section" aria-label="Social sign-in">
      <button type="button" class="provider-button" [disabled]="isLoading || isProviderLoading" (click)="continueWithGoogle()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M21.8 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.8 3.2-4.4 3.2-7.3Z"/><path fill="#34A853" d="M12 22c2.7 0 5-.9 6.6-2.5l-3.2-2.5c-.9.6-2 .9-3.4.9-2.6 0-4.8-1.7-5.6-4H3.1v2.6A10 10 0 0 0 12 22Z"/><path fill="#FBBC05" d="M6.4 13.9a6 6 0 0 1 0-3.8V7.5H3.1a10 10 0 0 0 0 9l3.3-2.6Z"/><path fill="#EA4335" d="M12 6.1c1.5 0 2.9.5 4 1.6l3-3A10 10 0 0 0 3.1 7.5l3.3 2.6c.8-2.3 3-4 5.6-4Z"/></svg>
        Continue with Google
      </button>
      <div class="auth-divider" aria-hidden="true"><span>or continue with email</span></div>
    </section>

    <!-- Login Form -->
    <form (ngSubmit)="onSubmit()" class="auth-form" novalidate>
      <!-- Email Field -->
      <div class="form-group">
        <label for="email" class="form-label">{{ 'EMAIL' | translate }}</label>
        <div class="input-wrapper" [class.invalid]="isEmailInputInvalid()">
          <ion-icon name="mail-outline" class="input-icon"></ion-icon>
          <input
            type="email"
            id="email"
            [(ngModel)]="email"
            (ngModelChange)="onCredentialsChanged()"
            name="email"
            class="form-input"
            [placeholder]="'EMAIL_PLACEHOLDER' | translate"
            autocomplete="email"
            #emailInput
            required
            />
          </div>
          @if (isEmailInputInvalid()) {
            <span class="error-text">
              {{ email.length ? ('INVALID_EMAIL' | translate) : ('EMAIL_REQUIRED' | translate) }}
            </span>
          }
        </div>

        <!-- Password Field -->
        <div class="form-group">
          <label for="password" class="form-label">{{ 'PASSWORD' | translate }}</label>
          <div class="input-wrapper" [class.invalid]="formSubmitted && !password.length">
            <ion-icon name="lock-closed-outline" class="input-icon"></ion-icon>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              [(ngModel)]="password"
              (ngModelChange)="onCredentialsChanged()"
              name="password"
              class="form-input"
              [placeholder]="'PASSWORD_PLACEHOLDER' | translate"
              autocomplete="current-password"
              #passwordInput
              required
              />
              <button
                type="button"
                class="password-toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                >
                <ion-icon [name]="showPassword ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
              </button>
            </div>
            @if (formSubmitted && !password.length) {
              <span class="error-text">{{ 'PASSWORD_REQUIRED' | translate }}</span>
            }
          </div>

          <!-- Remember Me & Forgot Password -->
          <div class="form-options">
            <label class="checkbox-label">
              <input
                type="checkbox"
                [(ngModel)]="rememberMe"
                name="rememberMe"
                class="checkbox-input"
                />
                <span class="checkbox-custom"></span>
                <span class="checkbox-text">{{ 'REMEMBER_ME' | translate }}</span>
              </label>
              <a routerLink="/forgot-password" class="forgot-link">
                {{ 'FORGOT_PASSWORD' | translate }}
              </a>
            </div>

            <!-- Submit Button -->
            <button
              type="submit"
              class="submit-button"
              [disabled]="isLoading"
              >
              @if (isLoading) {
                <ion-spinner name="crescent"></ion-spinner>
              }
              @if (!isLoading) {
                <span>
                  <ion-icon name="log-in-outline"></ion-icon>
                  {{ 'LOGIN_BUTTON' | translate }}
                </span>
              }
            </button>
          </form>

          <!-- Register Link -->
          <div class="auth-footer">
            <p>
              {{ 'NO_ACCOUNT' | translate }}
              <a routerLink="/register" class="register-link">{{ 'REGISTER_NOW' | translate }}</a>
            </p>
          </div>
        </div>
      </div>
